import comparisonChart from './comparisonchart';

comparisonChart(document.getElementById('comparison-chart-container'));
